/**
 * Content access in the UI: every plan and the free trial get the same access (R2, R5).
 *
 * `is_premium` is paid access as the backend reported it at sign-in; the trial end is
 * compared live, so an expired trial locks again without a reload. The backend enforces
 * the same rule (`User.has_access`); this only decides what the UI offers.
 */
import type { User } from '@/types';

/** True while the user's free trial has not ended. */
export function isTrialActive(user: User | null | undefined, now: Date = new Date()): boolean {
  if (!user?.trial_expires) return false;
  const trialEnd = new Date(user.trial_expires).getTime();
  return Number.isFinite(trialEnd) && trialEnd > now.getTime();
}

export function hasAccess(user: User | null | undefined, now: Date = new Date()): boolean {
  if (!user) return false;
  return user.is_premium || isTrialActive(user, now);
}
